/* global ajax_object */

/**
 * Blog archive — category filter + AJAX "load more".
 * Uses the `ajax_object` (url + nonce) localised in functions.php.
 */
const initBlog = (root) => {
  const grid = root.querySelector('[data-blog-grid]');
  const loadMore = root.querySelector('[data-blog-load-more]');
  const moreWrap = root.querySelector('.blog-archive__more');
  const tabs = Array.from(root.querySelectorAll('[data-blog-filter]'));

  if (!grid || typeof ajax_object === 'undefined') {
    return;
  }

  const exclude = root.dataset.exclude || '';
  const perPage = root.dataset.perPage || '9';
  let category = 'all';
  let busy = false;

  const request = (paged) =>
    fetch(ajax_object.ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'blog_posts',
        nonce: ajax_object.nonce,
        paged,
        category,
        exclude,
        per_page: perPage,
      }),
    }).then((response) => response.json());

  const setLoadMore = (data) => {
    if (!loadMore || !moreWrap) {
      return;
    }

    loadMore.dataset.paged = String(data.paged);
    loadMore.dataset.max = String(data.max);
    moreWrap.hidden = data.paged >= data.max || data.max <= 1;
  };

  const filter = (nextCategory) => {
    if (busy || nextCategory === category) {
      return;
    }

    busy = true;
    category = nextCategory;

    tabs.forEach((tab) => {
      const isActive = tab.dataset.blogFilter === category;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    grid.classList.add('is-loading');

    request(1)
      .then((res) => {
        if (res && res.success) {
          grid.innerHTML = res.data.html;
          setLoadMore(res.data);
        }
      })
      .finally(() => {
        grid.classList.remove('is-loading');
        busy = false;
      });
  };

  const append = () => {
    if (busy || !loadMore) {
      return;
    }

    busy = true;
    const next = (parseInt(loadMore.dataset.paged, 10) || 1) + 1;
    loadMore.classList.add('is-loading');

    request(next)
      .then((res) => {
        if (res && res.success) {
          grid.insertAdjacentHTML('beforeend', res.data.html);
          setLoadMore(res.data);
          document.dispatchEvent(new CustomEvent('reveal:scan'));
        }
      })
      .finally(() => {
        loadMore.classList.remove('is-loading');
        busy = false;
      });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => filter(tab.dataset.blogFilter));
  });

  if (loadMore) {
    loadMore.addEventListener('click', append);
  }
};

const initAll = () => {
  document.querySelectorAll('[data-blog]').forEach((root) => {
    if (root.dataset.blogInitialized) {
      return;
    }

    root.dataset.blogInitialized = 'true';
    initBlog(root);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
